import { Switch as BaseSwitch } from '@base-ui/react/switch';
import type { ReactNode } from 'react';
import { cx } from './utils';

export interface SwitchProps {
  label: ReactNode;
  checked?: boolean;
  defaultChecked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export function Switch({
  label,
  checked,
  defaultChecked,
  onCheckedChange,
  disabled = false,
  className,
}: SwitchProps) {
  return (
    <label className={cx('ui-check-row', className)}>
      <BaseSwitch.Root
        className="ui-switch"
        checked={checked}
        defaultChecked={defaultChecked}
        onCheckedChange={(nextChecked) => onCheckedChange?.(nextChecked)}
        disabled={disabled}
      >
        <BaseSwitch.Thumb className="ui-switch__thumb" />
      </BaseSwitch.Root>
      <span className="ui-check-row__label">{label}</span>
    </label>
  );
}
